import React, { useId, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

/**
 * File input with translated button and status text (replaces browser defaults).
 */
const TranslatedFileInput = ({
  id: idProp,
  name,
  className = "",
  accept,
  disabled = false,
  onChange,
  invalid = false,
  statusText,
}) => {
  const { t } = useTranslation()
  const generatedId = useId()
  const inputId = idProp || generatedId
  const inputRef = useRef(null)
  const [fileLabel, setFileLabel] = useState("")

  const handleChange = e => {
    onChange?.(e)
    setFileLabel(e.target.files?.[0]?.name || "")
  }

  return (
    <div className={`translated-file-input d-flex align-items-center flex-wrap gap-2 ${className}`}>
      <input
        ref={inputRef}
        type="file"
        id={inputId}
        name={name}
        className="d-none"
        accept={accept}
        disabled={disabled}
        onChange={handleChange}
      />
      <button
        type="button"
        className={`btn btn-outline-secondary btn-sm ${invalid ? "border-danger" : ""}`}
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
      >
        {t("Choose File")}
      </button>
      <span className="text-muted small">
        {fileLabel || statusText || t("No file chosen")}
      </span>
    </div>
  )
}

export default TranslatedFileInput
